import React from 'react';
import {BookingCheckInVO} from "../../../types/model/valueObject/booking/BookingCheckInVO";
import {SupplierBookingCheckInCardListItem} from "./SupplierBookingCheckInCardListItem";
import {withLoader} from "../../hocs/withLoader";
import {LocationCardSkeleton} from "../../common/reports/loadingSkeletons/LocationCardSkeleton";
import {ReportDialogSetterProps} from "../../../interfaces";

type SupplierBookingCheckInCardListProps = {
  items?: BookingCheckInVO[];
  onOpenDialog: (dialog: ReportDialogSetterProps<BookingCheckInVO>) => void;
}

const SupplierBookingCheckInCardList = ({
  items,
  onOpenDialog,
}: SupplierBookingCheckInCardListProps) => {
  if (!items?.length) {
    return null;
  }

  return <>
    {
      items.map((item) =>
        <SupplierBookingCheckInCardListItem
          key={item.bookingId}
          item={item}
          onOpenDialog={onOpenDialog}
        />
      )
    }
  </>
}

const skeletonLoader = () => Array.from({ length: 10 }).map((_, index) => (
  <LocationCardSkeleton key={index} />
));

const SupplierBookingCheckInCardListWithLoader = withLoader(SupplierBookingCheckInCardList, skeletonLoader);

export {
  SupplierBookingCheckInCardList,
  SupplierBookingCheckInCardListWithLoader
};
